<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>TERMOS DE USO</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">

        <div class="row">
        <div class="col-xs-12">
            <h3 class="box-title first">Termos de Uso</h3>
        </div>
        </div>
        <div class="row">
            <div class="col-xs-12 static-text">
                <h5><strong>Contrato de Confidencialidade</strong></h5>
                <p>Os dados disponibilizados no Direct-Client são CONFIDENCIAIS e de uso exclusivo da Revenda, que é responsável pela correta utilização dos meios eletrônicos que lhe são disponibilizados, obedecendo às normas estabelecidas pela Aldo e fabricantes, cabendo a ela utilizá-los somente para os fins específicos e, obrigando-se por si, por seus funcionários e contratados a manter os códigos de acesso e as informações em sigilo e proibir o acesso de pessoas não autorizadas ou terceiros.</p>
                <p>Caso a Revenda permita ou facilite o acesso de terceiros não autorizados, divulgue as informações do SITE (com ênfase nos preços e promoções) ou utilize-se do SITE para fins adversos aos aqui especificados FICA SUJEITA A PROCESSO JUDICIAL INDENIZATÓRIO, elegendo-se o Foro da Comarca de Maringá - Paraná, por mais privilegiado que outro seja, por perdas e danos morais no valor de 100 (CEM) SALÁRIOS MÍNIMOS.</p>
                <p>A concordância com os termos e condições expostas no SITE da Aldo se produzirá mediante cada acesso, que implica na declaração expressa da Revenda em conhecer e aceitar, sem ressalvas ou restrições, todos os termos e condições estabelecidas neste instrumento particular e nas condições comerciais estipuladas pela Aldo, bem como qualquer outro termo ou condição expresso nas consultas ou nos pedidos de compra que vier a realizar, salvo quando existir acordo específico entre as partes.</p>
                <p>A Revenda está autorizada a divulgar as informações sobre características dos produtos contidas no SITE da Aldo, obedecendo, logicamente, orientações de confidencialidade dos fabricantes.</p>
                <p>Destacamos que todas as imagens que constam no site são meramente ilustrativas, utilizadas apenas como referência e não apresentando nenhuma obrigação de legitimidade por parte da Aldo.</p>
            </div>
        </div>
        
        <button aria-label="Contrato de Revenda da Aldo" class="btn primary-button" target="_blank" onclick="window.open('/arquivos/aldo-contrato-comercial.pdf','_blank');">
          <i class="fa fa-download"></i> Contrato de Revenda da ALDO
        </button>
        
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "termsOfUse"
};
</script>
